import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface';
import { useReportDataGetSaleReportsQuery } from '@sales/data/reports/ReportDataQueries';
import { SaleReport, SaleReportCategory } from '@sales/data/reports/ReportData';
import ReportCard from '../../reports/components/cards/ReportCard';

const REPORT_CATEGORIES: { category: SaleReportCategory, icon: string, tourId: string }[] = [
    { category: 'Sale',      icon: 'fas fa-chart-area', tourId: 'sale-reports-sale-section' },
    { category: 'Lots',      icon: 'fas fa-list',        tourId: 'sale-reports-lots-section' },
    { category: 'Financial', icon: 'fas fa-dollar-sign', tourId: 'sale-reports-financial-section' },
];

const SaleReportsPage = () => {
    const reportsQuery = useReportDataGetSaleReportsQuery();

    return (
        <AgTechQueryLoadingSurface
            query={reportsQuery}
            content={{
                loadingText: 'Loading reports...',
                failureText: 'Failed to load reports'
            }}
        >
            {(reports) => (
                <div className='stretched py-6 px-6 row-based scrollable flex'>
{REPORT_CATEGORIES.map(({ category, icon, tourId }) => {
                        const group = reports.filter(r => r.reportCategory === category);
                        if (group.length === 0) return null;

                        return (
                            <ReportCategorySection
                                key={category}
                                category={category}
                                icon={icon}
                                reports={group}
                                tourId={tourId}
                            />
                        );
                    })}
                </div>
            )}
        </AgTechQueryLoadingSurface>
    );
}

type ReportCategorySectionProps = {
    category: SaleReportCategory,
    icon: string,
    reports: SaleReport[],
    tourId: string,
}

const ReportCategorySection = (props: ReportCategorySectionProps) => (
    <div id={props.tourId} className='wide row-based mb-8 flex'>
        <div className='column-based-vertically-centered wide mb-4 pb-3 border-b flex'>
            <i className={`${props.icon} text-detail mr-3`} />
            <h2 className='font-semibold text-base'>{props.category} Reports</h2>
        </div>
        <div className='wide grid gap-4 flex' style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {props.reports.map(report => (
                <ReportCard key={report.reportName} {...report} />
            ))}
        </div>
    </div>
);

export default SaleReportsPage;
